import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const DuplicateDayDialog = ({
  open,
  patrolCount,
  guardName,
  sourceDayLabel,
  targetDayLabel,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ContentCopyIcon sx={{ color: 'primary.main' }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Duplicate Shift to Next Day
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          <strong>{patrolCount} patrol{patrolCount !== 1 ? 's' : ''}</strong> for <strong>{guardName}</strong> will be duplicated from <strong>{sourceDayLabel}</strong> to <strong>{targetDayLabel}</strong>.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Duplicate {patrolCount} Patrol{patrolCount !== 1 ? 's' : ''}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DuplicateDayDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  patrolCount: PropTypes.number.isRequired,
  guardName: PropTypes.string,
  sourceDayLabel: PropTypes.string,
  targetDayLabel: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default memo(DuplicateDayDialog);
